module.exports = "<highcharts-chart [Highcharts]=\"Highcharts\" [options]=\"chartOptionsdos\" style=\"width: 100%; display: block;\">\n</highcharts-chart>"